import { render, staticRenderFns } from "./RecoverModal.vue?vue&type=template&id=cafe3ee8"
import script from "./RecoverModal.vue?vue&type=script&lang=js"
export * from "./RecoverModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports